import React from 'react';
import ContactUsBanner from './ContactUsBanner';
import Form from './Form';

const ContactUsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main>
        <ContactUsBanner />
        <Form />
      </main>
    </div>
  );
};

export default ContactUsPage;
